module.exports = __webpack_public_path__ + "static/media/Intro.7f11b4ff.mp4";